import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/core/services/app-config.service';
import { AppServiceService } from 'src/app/core/services/app-service.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  textH2:string;
  LoginMoe:boolean;
  loginType:string;
  links: any;
  constructor(private service:AppServiceService, private appConfigService: AppConfigService ) { }

  ngOnInit(): void {
    this.loginType = this.service.loginType;
    this.appConfigService.getLinks().subscribe(    
      (data) => { 
        this.links = data[this.loginType];
      },
      (error) => {
        //TODO
      })
    this.LoginMoe = this.service.isMoeLogin
    if(this.LoginMoe){
     this.textH2 = "הזדהות עובדי משרד החינוך";
    }
    else{
      this.textH2 ="ברוכים הבאים למשרד החינוך";
      ;
    }
  }
  

}
